import { DateSearchParam } from "../../utils/dateSearchParam";
import { AvailableStatus } from "../../utils/availableStatus";
import { clearExerciseSaleFilters, searchExerciseSale } from "./exerciseSaleFiltersActions";
import { Identifiable } from "../../models/Identifiable";
import { ExerciseSaleSearchParams } from "../../models/ExerciseSaleSearchParams";

export interface ExerciseSaleFiltersState {
  searchParams: ExerciseSaleSearchParams;
}

const initialExerciseSaleFilters: ExerciseSaleFiltersState = {
  searchParams: {
    dateSearchParam: DateSearchParam.day,
    available: AvailableStatus.both,
    dateFrom: new Date(),
    dateTo: new Date(),
    exerciseGroupIds: {} as Identifiable,
    zoneIds: {} as Identifiable,
    passIds: "",
    minFreePlaces: 0,
    timeFrom: new Date(new Date().setHours(0, 0, 0, 0)),
    timeTo: new Date(new Date().setHours(23, 59, 0, 0)),
    dayTypes: [],
    internet: false,
  },
};

export default function exerciseSaleFiltersReducer(exerciseSaleFilters = initialExerciseSaleFilters, action: any) {
  switch (action.type) {
    case searchExerciseSale.toString():
      return {
        ...exerciseSaleFilters,
        searchParams: action.payload.search,
      };
    case clearExerciseSaleFilters.toString():
      return initialExerciseSaleFilters;
    default:
      return exerciseSaleFilters;
  }
}
